import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'pharmacy', en);

const PharmacyProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Pharmacy Profile',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PHARMACY,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/pharmacy/:id/profile',
      component: React.lazy(() => import('./PharmacyProfile')),
    },
  ],
};

export default PharmacyProfileConfig;
